import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('decision-tree');

app.factory('DecisionTree', resource);
